export function groupTypeLabel(groupType) {
    return ({
        AD: 'sp-group-type.ad',
        AD_DOMAIN: 'sp-group-type.ad-domain',
        AD_GROUP: 'sp-group-type.ad-group',
        AD_OU: 'sp-group-type.ad-ou',
        APPLICATION: 'sp-group-type.application',
        CUSTOM: 'sp-group-type.custom',
        DOMAIN: 'sp-group-type.domain',
        EVERYONE: 'sp-group-type.everyone',
        EXTERNAL_EMAILS: 'sp-group-type.external-emails',
        PHONE_NUMBERS: 'sp-group-type.phone-numbers',
        UNKNOWN: 'sp-group-type.unknown',
    })[groupType];
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-group-type/sp-group-type.exports.js